export default __webpack_public_path__ + "static/blueprint-1ae0938892338fdaab22ce4012ec3dac.png";